import React from 'react';

type Props = {
  onClickElement?: () => void,
  className: string
} & typeof defaultProps;

const defaultProps = {
  onClickElement: () => { },
};

const PinItemSvg = function PinItemSvg(props: Props) {
  const { onClickElement, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      onClick={onClickElement}
      className={`pinShow ${className}`}
    >
      <path d="M11.2354 0.983398C11.466 0.730957 11.8626 0.747412 12.0977 0.982422L17.0586 5.94434C17.1775 6.06331 17.2412 6.217 17.2412 6.375C17.2411 6.52281 17.1823 6.68675 17.0283 6.79395L15.5703 8.25293C15.4514 8.37176 15.2976 8.43552 15.1396 8.43555C14.9817 8.43555 14.8279 8.37171 14.709 8.25293L14.126 7.66992L11.0771 10.7188L10.957 13.5566L10.9561 13.5557C10.9538 13.7211 10.8827 13.8497 10.7744 13.958L9.74121 14.9912C9.62233 15.1101 9.46845 15.1737 9.31055 15.1738C9.19202 15.1738 9.07545 15.1384 8.97461 15.0703L8.87891 14.9912L6.39355 12.4863L1.84375 17.0166C1.72475 17.1356 1.57116 17.2002 1.41309 17.2002C1.25514 17.2001 1.10133 17.1365 0.982422 17.0176C0.738942 16.7741 0.738942 16.3988 0.982422 16.1553H0.983398L5.5127 11.6045L3.0293 9.12109C2.9103 9.0021 2.84668 8.84752 2.84668 8.68945C2.84681 8.53155 2.91042 8.37767 3.0293 8.25879L3.03027 8.25781L4.05664 7.25195C4.16252 7.12229 4.32052 7.06549 4.46484 7.06348L7.30078 6.94238L10.3496 3.89355L9.76855 3.31152C9.52509 3.06804 9.52508 2.69367 9.76855 2.4502L11.2354 0.982422V0.983398ZM11.0605 2.88086L11.6426 3.46289C11.8555 3.67585 11.8822 3.98942 11.7227 4.22754L11.6426 4.3252L7.9834 7.96387L7.98242 7.96289C7.87697 8.08722 7.72435 8.14124 7.58301 8.14355L7.58398 8.14551L4.76562 8.28613L4.3418 8.70996L9.30957 13.6777L9.7334 13.2539L9.875 10.416H9.87598C9.87888 10.2519 9.94994 10.1243 10.0576 10.0166V10.0156L13.7168 6.37793L13.8115 6.29883C13.9124 6.23075 14.0289 6.19531 14.1475 6.19531C14.3055 6.19536 14.4592 6.25898 14.5781 6.37793L15.1611 6.96094L15.7432 6.39355L11.6455 2.29492L11.0605 2.88086Z" fill="#2F363A" stroke="#2F363A" strokeWidth="0.4" />
    </svg>
  );
};
PinItemSvg.defaultProps = defaultProps;
export default PinItemSvg;
